{
    "AgentList_AddButton_DisabledTooltip": "Seleziona un server di telefonia e una partizione nei filtri qui sopra per aggiungere un agente.",
    "AgentList_Column_AgentNumber": "Numero dell'agente",
    "AgentList_Column_PartitionId": "ID della partizione",
    "AgentList_Column_Monitored": "Monitorato",
    "AgentList_Monitored_Yes": "SÌ",
    "AgentList_Monitored_No": "NO",
    "AgentList_Column_Description": "Descrizione",
    "AgentList_Column_InternalNumber": "numero interno",
    "AgentList_Column_PartitionName": "Nome della partizione",
    "AgentList_Column_OmniChannel": "Omnicanale",
    "NAME": "Elenco agentiLingua"
}